import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import React from 'react';
import {View, Image, StyleSheet} from 'react-native';

const OTBEmptyState = ({onAddGame}: {onAddGame: () => void}) => {
  const steps = [
    <>
      Click on <CCText style={styles.highlight}>Add Game</CCText>.
    </>,
    'Fill in the details and submit the form.',
    <>
      A new row will appear — click on{' '}
      <CCText style={styles.highlight}>Feed Game</CCText>.
    </>,
    'Upload a PGN file or feed the moves by playing on the board.',
    '(Optional) Upload a score sheet image for easy reference.',
  ];

  return (
    <View style={styles.outerContainer}>
      <CCText style={styles.mainHeading}>OTB Games</CCText>
      <View
        style={{
          backgroundColor: CCColors?.White,
          paddingVertical: '5%',
          paddingHorizontal: '10%',
          borderRadius: 8,
          elevation: 4,
          shadowColor: '#000',
          shadowOpacity: 0.1,
          shadowRadius: 8,
        }}>
        <Image
          source={require('@/Assets/Images/Otb/corner_pattern.svg')}
          style={[styles.pattern, styles.topLeft]}
          resizeMode="contain"
        />
        <Image
          source={require('@/Assets/Images/Otb/corner_pattern.svg')}
          style={[styles.pattern, styles.topRight]}
          resizeMode="contain"
        />
        <Image
          source={require('@/Assets/Images/Otb/corner_pattern.svg')}
          style={[styles.pattern, styles.bottomLeft]}
          resizeMode="contain"
        />
        <Image
          source={require('@/Assets/Images/Otb/corner_pattern.svg')}
          style={[styles.pattern, styles.bottomRight]}
          resizeMode="contain"
        />

        <View style={styles.card}>
          <View style={styles.leftSection}>
            <Image
              source={require('@/Assets/Images/Otb/otb_image.svg')}
              style={styles.image}
              resizeMode="contain"
            />
            <CCText style={styles.heading}>What is OTB</CCText>
            <CCText style={styles.description} numberOfLines={3}>
              OTB stands for Over The Board. Here, you can feed and analyse all
              the games that you play in offline tournaments.
            </CCText>
          </View>
          <View style={styles.rightSection}>
            <Image
              source={require('@/Assets/Images/Otb/card_pattern.svg')}
              style={styles.cornerImage}
            />
            <View style={{padding: 40}}>
              <CCText style={styles.rightHeading}>How to Add a OTB game</CCText>
              {steps.map((text, index) => (
                <View style={styles.stepContainer} key={index}>
                  <View style={styles.stepNumber}>
                    <CCText style={styles.stepNumberText}>{index + 1}</CCText>
                  </View>
                  <CCText style={styles.stepDescription}>{text}</CCText>
                </View>
              ))}
              <CCButton
                style={styles.addButton}
                onPress={onAddGame}
                titleStyle={{
                  color: CCColors.TextColor.Dark,
                  fontSize: FontSizes[14],
                  lineHeight: 24,
                  fontWeight: '500',
                }}>
                Add Game
              </CCButton>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    height: '100vh',
    backgroundColor: '#FAF7ED',
    padding: 32,
    justifyContent: 'flex-start',
  },
  mainHeading: {
    fontSize: FontSizes[24],
    fontWeight: '500',
    color: CCColors?.TextColor?.Dark,
    marginBottom: 32,
  },
  pattern: {
    position: 'absolute',
    width: 151,
    height: 150,
  },
  topLeft: {
    top: 0,
    left: 0,
    transform: [{rotate: '0deg'}],
  },
  topRight: {
    top: 0,
    right: 0,
    transform: [{rotate: '90deg'}],
  },
  bottomLeft: {
    bottom: 0,
    left: 0,
    transform: [{rotate: '-90deg'}],
  },
  bottomRight: {
    bottom: 0,
    right: 0,
    transform: [{rotate: '180deg'}],
  },
  card: {
    flexDirection: 'row',
    borderRadius: 12,
    overflow: 'hidden',
    backgroundColor: CCColors?.White,
    borderWidth: 1,
    borderColor: CCColors?.BorderBottom,
  },
  leftSection: {
    flex: 1,
    backgroundColor: CCColors?.White,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
    paddingHorizontal: 24,
  },
  image: {
    width: 180,
    height: 180,
  },
  heading: {
    fontSize: FontSizes[14],
    fontWeight: '500',
    marginTop: 16,
    marginBottom: 8,
    color: CCColors?.TextColor?.Dark,
  },
  description: {
    width: '60%',
    fontSize: FontSizes[12],
    fontWeight: '400',
    color: updateColorWithOpacity(CCColors?.TextColor?.Dark, 0.7),
    textAlign: 'center',
    lineHeight: 20,
  },
  rightSection: {
    flex: 1,
    paddingVertical: 70,
    justifyContent: 'space-between',
    backgroundColor: CCColors?.menuBackground?.main,
  },
  cornerImage: {
    position: 'absolute',
    width: '100%',
    height: 64,
    top: 0,
  },
  rightHeading: {
    color: CCColors?.White,
    fontSize: FontSizes[14],
    fontWeight: '600',
    marginBottom: 20,
  },
  stepContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 14,
  },
  stepNumber: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: CCColors?.Green,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  stepNumberText: {
    color: CCColors?.White,
    fontSize: FontSizes[18],
    fontWeight: '500',
  },
  stepDescription: {
    flex: 1,
    color: updateColorWithOpacity(CCColors?.White, 0.8),
    fontSize: FontSizes[12],
    fontWeight: '400',
    lineHeight: 20,
  },
  highlight: {
    fontWeight: '600',
    color: CCColors?.Primary?.Default,
  },
  addButton: {
    justifyContent: 'center',
    marginTop: 24,
  },
});

export default OTBEmptyState;
